// Shared plan definitions and utilities for both admin and widget

export const plans = [
  {
    id: 'Free',
    name: 'Free',
    price: '$0',
    priceSuffix: '/month',
    features: [
      '100 Automated replies/month',
      'AI training',
      'Order tracking',
      '1 agent'
    ]
  },
  {
    id: 'Basic',
    name: 'Basic',
    price: '$9.99',
    priceSuffix: '/month',
    features: [
      '500 Automated replies/month',
      'AI training',
      'Order tracking',
      '3 support agents',
      'General product recommendations',
      'Order based product recommendations'
    ]
  },
  {
    id: 'Standard',
    name: 'Standard',
    price: '$19.99',
    priceSuffix: '/month',
    highlight: 'Recommended',
    features: [
      'All the features in Basic',
      '2,000 Automated replies/month',
      'Live chat',
      'Chatbot Customization',
      'Multi-language support',
      '10 support agents',
      'Removed branding for Chatbot'
    ]
  },
  {
    id: 'Premium',
    name: 'Premium',
    price: '$49.99',
    priceSuffix: '/month',
    features: [
      'All the features in Standard',
      '10,000 Automated replies/month',
      'Unlimited support agents'
    ]
  }
];

// Utility to resolve all features for a plan, recursively
export function getResolvedFeatures(planId, plansArr = plans, options = {}) {
  // If options.uiOnly is true, do NOT expand inherited features for UI display
  const plan = plansArr.find(p => p.id === planId);
  if (!plan) return [];
  if (options.uiOnly) return plan.features;
  let features = [];
  plan.features.forEach(f => {
    const match = f.match(/^All the features in (.+)$/);
    if (match) {
      features = [...features, ...getResolvedFeatures(match[1], plansArr)];
    } else {
      features.push(f);
    }
  });
  return features;
}
